"use strict";
function DeprecatedMethod(msg) {
    return function (target, key, descriptor) {
        var original = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            console.warn(msg);
            return original.apply(this, args);
        };
        return descriptor;
    };
}
exports.DeprecatedMethod = DeprecatedMethod;

//# sourceMappingURL=Deprecated.js.map
